import React, { forwardRef } from "react";
import styles from "./Input.module.css";
import classNames from "classnames";
import DateInput from "./DateInput";

interface InputProps {
	minDate?: Date;
	filterDate?: (date: Date) => boolean;
	onEnterPress?: ({
		name,
		value,
		e,
	}: {
		name: string;
		value: string;
		e: React.KeyboardEvent;
	}) => void;
	labelClassName?: string;
	unit?: string;
	inputClassName?: string;
	className?: string;
	onChange?: ({
		name,
		value,
		e,
	}: {
		name: string;
		value: string;
		e: React.ChangeEvent<HTMLInputElement>;
	}) => void;
	type?: string;
	name?: string;
	value?: any;
	required?: boolean;
	placeholder?: string;
	label?: string;
	disabled?: boolean;
	ref?: React.Ref<HTMLInputElement>;
}

const Input: React.FC<InputProps> = forwardRef<HTMLInputElement, InputProps>(
	(
		{
			minDate,
			filterDate,
			onEnterPress,
			labelClassName,
			unit,
			inputClassName,
			...props
		},
		ref
	) => {
		const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
			const { key, target } = e;
			const inputTarget = target as HTMLInputElement;

			const name = inputTarget.name;
			const value = inputTarget.value;

			if (key === "Enter") {
				onEnterPress?.({ name, value, e });
			}
		};

		return (
			<div>
				{!!props.label && (
					<div className={classNames(styles.label, labelClassName)}>
						{props.label}
					</div>
				)}
				<div className={classNames(styles.container, props.className)}>
					{props.type === "date" || props.type === "datetime" ? (
						<DateInput
							selected={props.value}
							minDate={minDate}
							onChange={props.onChange}
							name={props.name}
							type={props.type}
							disabled={props.disabled}
							placeholder={props.placeholder}
							filterDate={filterDate}
						/>
					) : (
						<>
							<input
								{...props}
								value={
									"value" in props
										? props.value ?? ""
										: undefined
								}
								className={classNames(
									styles.input,
									{
										[styles.disabled]: props.disabled,
									},
									inputClassName
								)}
								onChange={(e) =>
									!props.disabled &&
									props.onChange?.({
										name: props.name!,
										value: e.target.value,
										e,
									})
								}
								onKeyUp={onKeyUp}
								ref={ref}
							/>
							{!!unit && (
								<p className={styles.placeholder}>{unit}</p>
							)}
						</>
					)}
				</div>
			</div>
		);
	}
);

export default Input;
